import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Button, Container, TextField, Typography} from "@mui/material";
import {verifyEmailOtp} from "../api/api";

const VerifyOtpPage = () => {
    const {t} = useTranslation();

    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email;

    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const res = await verifyEmailOtp(email, otp);
            navigate("/reset-password", {state: {resetSessionToken: res.resetSessionToken}});
        } catch (err: any) {
            setError(err.message ?? t("verifyotp.errors.invalidOtp"));
        }
    };

    return (
        <Container maxWidth="xs">
            <Box py={10}>
                <Box p={3} boxShadow={3} borderRadius={2}>
                    <Typography variant="h5" align="center" gutterBottom>
                        {t("verifyotp.title")}
                    </Typography>

                    {error && (
                        <Typography color="error">
                            {error}
                        </Typography>
                    )}

                    <form onSubmit={handleVerify}>
                        <TextField
                            fullWidth
                            label={t("verifyotp.otpCode")}
                            margin="normal"
                            required
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />

                        <Button type="submit" fullWidth variant="contained" sx={{mt: 2}}>
                            {t("verifyotp.verify")}
                        </Button>
                    </form>
                </Box>
            </Box>
        </Container>
    );
};

export default VerifyOtpPage;